<template>
  <div v-if="(measKind=='measures' || measKind=='lab' || measKind=='elab') && nonVitalExists()" class="icon-container">
    <!-- TODO: disable + for vitals -->
    <!-- if watching, should be able to remove -->
    <button  v-if="isThereMeasure()"
             @click.stop="removeCdaMeasuresFromWatch"
             class="icon__btn icon__btn--small icon--minus">
      <span>Trend −
        <!-- <font-awesome-icon icon="minus-circle" class="mr-md-2 mr-2 icon--minus" /> -->
      </span>
    </button>

    <!-- else, should be able to add -->
    <button  v-else
             @click.stop="addCdaMeasuresToWatch"
             class="icon__btn icon__btn--small icon--plus">
      <span>Trend +
        <!-- <font-awesome-icon icon="plus-circle" class="mr-md-2 mr-2 icon--plus" /> -->
      </span>
    </button>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import router from '@/router/index';
  import { WatchNavigation } from '@/store/modules/fsm/messages';

  export default {
    name: "watch-button-cda",
    props: {
      items: null,
      measKind: null
    },
    computed: {
      ...mapGetters('login/watch', {
        measuresInWatchList: 'getMeasuresWatching',
        vitalCcds: 'getVitalSignCodes',
      }),
    },
    data () {
      return {
        isThereMeasure: () => {
          let answer = false
          this.forEachSidebarMeasure((meas) => {
            const ccd = parseInt(meas.ccd, 10);
            if (this.measuresInWatchList.hasOwnProperty(meas.ccd)
              && (!this.vitalCcds.length || !this.vitalCcds.includes(ccd))) {
              answer = true
            }
          })
          return answer
        }
      }
    },
    methods: {
      ...mapActions('login/watch', [
        'addMeasure',
        'removeMeasure',
      ]),
      forEachSidebarMeasure(callback) {
        Object.values(this.items).forEach((dates) => {
          dates.forEach((item) => {
            if (item.measures && item.measures.length) {
              item.measures.forEach((meas) => callback(meas));
            } else {
              callback(item);
            }
          });
        });
      },
      nonVitalExists() {
        let answer = false
        this.forEachSidebarMeasure((meas) => {
          const ccd = parseInt(meas.ccd, 10);
          if (!this.vitalCcds.length || !this.vitalCcds.includes(ccd)) {
            answer = true
          }
        })
        return answer
      },
      async addCdaMeasuresToWatch() {
        this.forEachSidebarMeasure((meas) => {
          const ccd = parseInt(meas.ccd, 10);
          if (this.vitalCcds.length && this.vitalCcds.includes(ccd)) return;
          this.addMeasure({
            proc: meas.procCcd || null,
            meas: meas.ccd
          })
        })
        router.push({name:WatchNavigation})
      },
      async removeCdaMeasuresFromWatch() {
        this.forEachSidebarMeasure((meas) => {
          const ccd = parseInt(meas.ccd, 10);
          if (this.vitalCcds.length && this.vitalCcds.includes(ccd)) return;
          this.removeMeasure({
            proc: meas.procCcd || null,
            meas: meas.ccd
          })
        })
      },

    },

  }
</script>

<style scoped lang="scss">
  $color-base: #0060ff;

  .icon-container {
    position: relative;
    width: fit-content;
    float: right;
    .icon__btn {
      color: white;
      border-radius: 20px;
      border: none;
      margin-top: 4px;
      padding-top: 10%;
      /*padding-bottom: 30%;*/
      font-size: 1.2rem;
    }

    .icon__btn--small {
      background-color: transparent;
      font-size: 1.0rem;
    }

    .icon--plus {
      background-color: $color-base;
      &:hover {
        cursor: pointer;
        background-color: darken($color-base, 20%);
      }
    }

    .icon--minus {
      background-color: #ff4444;
      &:hover {
        cursor: pointer;
        background-color: #cc0000;
      }
    }

  }
</style>